import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const AdminGuard = ({ children, ...rest }) => {
  const token = localStorage.getItem("token:data");

  const { profile } = useSelector((state) => state.users);

  let isAdminGuard = profile
    ? (profile &&
        profile.role && profile.role.map((role) => role.name).includes("admin"))
    : false;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        token && isAdminGuard ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: {
                from: location,
              },
            }}
          />
        )
      }
    />
  );
};

export default AdminGuard;
